import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Card, Row, Col, SubParagraph } from '../../../legacy/hui/src/styled/';
import feedbackTickIcon from '../../images/feedback-tick-icon.svg';
import installTick from '../../images/install-tick.png';
import styled from 'styled-components';
import { ButtonSubmit } from '../Bunnings/Buttons';
import Categories from '../../constants/Categories';

const modalStyle = {
  overlay: {
    position: 'fixed',
    zIndex: 9999,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    overflowY: 'auto',
    height: '100%'
  },
  content: {
    border: 'none',
    borderRadius: '8px',
    outline: 'none',
    padding: '0',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '95%',
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch'
  }
};

export const TitleCard = Card.Section.extend`
  display: flex;
  align-items: center; 
  position: relative;
  justify-content: center; 
  font-size: 16px;
  color: #0d5257;
  font-weight: 600;
  min-height: 60px;
`;

export const BottomCard = Card.Section.extend`
  display: flex;
  align-items: center; 
  position: relative;
  justify-content: center; 
  font-size: 15px;
  color: #fff;
  background-color: #0D5257;
  min-height: 60px;
`;

const FeedbackTickIcon = styled.img`
  height: 35px;
  @media (min-width: ${props => props.theme.breakpoints.sm}rem) {
    padding-right: 1.2rem;
    flex-shrink: 0;
  }
`;

const ModalCard = Card.extend`
  max-width: 1100px;
`;

const MediaCard = styled.div`
  padding: 5px 10px;
  overflow: hidden;
  display: block;
  margin: 0 auto;
  max-width: 300px;
`;

const ModalRow = Row.extend`
  width: 100%;
`;

const ParagraphSection = styled.div`
  padding: 0 20px;
  padding-top: 10px;
  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    padding-top: 5px;
  }
`;

const BeforeTitle = styled.div`
  font-size: 32px;
  margin: 20px;
  font-weight: 300;
  color: #434447;
`;

const AfterTitle = styled.div`
  font-size: 14px;
  margin: 40px 20px;
  color: #434447;
`;

export const Logo = styled.div`
  width: 42px;
  height: 29px;
  background: url(${installTick}) no-repeat;
  text-indent: -99999px;
  display: inline-block;
  background-size: contain;
  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    background: url(${props => props.logo}) no-repeat;
    width: 187px;
    height: 172px;
    background-size: contain;
  }
`;

const Link = styled.a`
  color: #da291c;
`;

export const TextDesktop = styled.div`
  display: none;
  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    display: inline-block;
  }
`;

export const TextMobile = styled.div`
  display: inline-block;
  padding-left: 10px;
  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    display: none;
  }
`;

const body = typeof document !== 'undefined' ? document.querySelector('body') : {};

const illustrations = sections => {
  if (Array.isArray(sections) === false) {
    return false;
  }
  const { length } = sections;
  const md = length === 2 ? 6 : length === 3 ? 4 : 0;
  if (md === 0) {
    return false;
  }
  return sections.map((section, index) => (
    <Col xs={12} md={md} key={index}>
      <MediaCard>
        <Logo logo={section.image} />
        <ParagraphSection>
          <SubParagraph>{section.text}</SubParagraph>
        </ParagraphSection>
      </MediaCard>
    </Col>
  ));
};

export class InstallModal extends Component {
  static propTypes = {
    continueToEnquire: PropTypes.func,
    categories: PropTypes.array,
    isOpen: PropTypes.bool
  };

  render() {
    const { isOpen, continueToEnquire, categories } = this.props;
    const cid =
      Array.isArray(categories) && categories[0].categoryId ? categories[0].categoryId : 0;
    const categoryKey = Array.isArray(categories) && categories[0].key ? categories[0].key : '';
    let data = {};
    if (cid === 0) {
      return false;
    }
    data = Categories[cid];
    if (cid === 0) {
      return false;
    }

    return (
      <Modal isOpen={isOpen} style={modalStyle} appElement={body}>
        <ModalCard center snow mt={0} mb={0} p={0} style={{ borderBottom: '1px solid #0D5257' }}>
          <TitleCard secondary p={1} pr={2}>
            <FeedbackTickIcon src={feedbackTickIcon} />
            <TextDesktop>Code accepted! Let&#39;s start your {data.name}</TextDesktop>
            <TextMobile style={{ textAlign: 'left' }}>
              Code accepted! Let&#39;s start your {data.name}
            </TextMobile>
          </TitleCard>
          <Card.Section style={{ boxShadow: 'none' }}>
            <ModalRow>
              <Col xs={12}>
                <BeforeTitle>Before we get started, please ensure...</BeforeTitle>
              </Col>
            </ModalRow>
            <ModalRow>{illustrations(data.sections)}</ModalRow>
            <Col xs={12}>
              <ButtonSubmit
                style={{ width: 180, borderRadius: '100px' }}
                onClick={() => continueToEnquire(categoryKey)}
              >
                Continue
              </ButtonSubmit>
            </Col>
            <Col xs={12}>
              <AfterTitle>
                {`Installations conflicting with the above scenarios will incur additional charges.`}
                <br />
                {`By tapping 'Continue' you agree to the Bunnings ${data.service} Service `}
                <Link href={`https://www.bunnings.com.au/${data.faq}-faqs`} target="_blank">
                  terms and conditions.
                </Link>
              </AfterTitle>
            </Col>
          </Card.Section>
          <BottomCard p={1} pr={2}>
            <TextDesktop>
              Got a question about your install? Give us a call 1300 043 520
            </TextDesktop>
            <TextMobile>
              Got a question about your install?
              <br />
              Give us a call 1300 043 520
            </TextMobile>
          </BottomCard>
        </ModalCard>
      </Modal>
    );
  }
}
